<template>
  <e-modal
    :visible="visible"
    :title="title"
    :width="700"
    :loading="loading"
    @close="onClose"
    @ok="onOk"
  >
    <a-spin tip="Loading..." :spinning="loading">
      <a-form>
        <div class="part">
          <a-row>
            <a-col :span="20">
              <e-input
                title="姓名\手机号"
                :labelCol="6"
                :valueCol="18"
                v-model:value="key"
              />
            </a-col>
            <a-col>
              <a-button @click="onSearchUser">查询</a-button>
            </a-col>
          </a-row>
          <a-empty v-if="users.length === 0" :image="simpleImage" />
          <div class="part-body" v-else>
            <a-row>
              <a-col :span="8" v-for="(v, k) in users" :key="k">
                <div
                  :class="{ 'user-box': true, on: index === k }"
                  @click="onChooseUser(k)"
                >
                  <div class="user">
                    <div class="avatar">
                      <img :src="v.avatar" :alt="v.name" />
                    </div>
                    <div class="info">
                      <div class="name">{{ v.name }}</div>
                      <div class="wx-name">{{ v.mobile }}</div>
                      <div class="wx-name">
                        {{ v.department ? v.department.name : "暂无区域" }}
                      </div>
                    </div>
                  </div>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </a-form>
    </a-spin>
  </e-modal>
</template>

<script>
import { defineComponent, ref } from 'vue'
import { UserClass } from '@/apis/user'
import { Empty } from 'ant-design-vue'

const user = new UserClass()
export default defineComponent({
  components: {},
  emits: ['ok'],
  props: {
    roleIds: {
      type: Array,
      default: () => []
    }
  },
  setup (props, { emit }) {
    const loading = ref(false)
    const visible = ref(false)
    const title = ref('')

    const key = ref('')
    const users = ref([])
    const index = ref(-1)

    const onChooseUser = (e) => {
      index.value = e
    }

    const onClose = () => {
      users.value = []
      index.value = -1
      key.value = ''
      loading.value = false
      visible.value = false
    }

    const onOk = () => {
      if (index.value > -1) {
      } else {
        index.value = 0
      }

      const data = users.value[index.value]
      emit('ok', data)
      onClose()
    }

    return {
      title,
      visible,
      loading,
      key,
      users,
      index,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,

      onClose,
      onChooseUser,
      onOk
    }
  },

  methods: {
    open (department) {
      this.department = department
      this.onSearchUser()
      this.title = '查询用户'
      this.visible = true
    },

    onSearchUser () {
      const q = {
        Limit: 999999,
        RoleId: 4,
        DepartmentId: this.department.id
      }
      if (this.key) {
        q.Key = this.key
      }

      user.gets(q).then((resp) => {
        this.index = -1
        this.users = resp.data
      })
    }
  }
})
</script>

<style lang="less" scoped>
.part {
  .part-body{
    height: 276px;
    overflow-y: auto;
  }
}
.user-box {
  padding: 5px;
  .user {
    display: flex;
    background: #f1f1f1;
    padding: 5px;
    border-radius: 6px;
    cursor: pointer;
    border: 1px solid #f1f1f1;
    .avatar {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      overflow: hidden;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .info {
      padding-left: 10px;
      .name {
        font-size: 18px;
        line-height: 30px;
      }
      .wx-name {
        font-size: 12px;
      }
    }
  }
  &.on {
    .user {
      border-color: #f50;
    }
  }
}
</style>
